import { defineMessages } from '@cookbook/solid-intl'

// Split out of `faq-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Find answers to general questions on Lodgr. Learn about bookings, hosting, payments and policies.',
        id: 'FAQPage.descriptionMessage',
    }),
    descriptionMessageBookings: defineMessages({
        defaultMessage: 'Find answers to bookings questions on Lodgr. Learn about search, confirmations, cancellations and support.',
        id: 'FAQPage.descriptionMessage.bookings',
    }),
    descriptionMessageGeneral: defineMessages({
        defaultMessage: 'Find answers to general questions on Lodgr. Learn about bookings, hosting, payments and policies.',
        id: 'FAQPage.descriptionMessage.general',
    }),
    descriptionMessageHosting: defineMessages({
        defaultMessage: 'Find answers to hosting questions on Lodgr. Learn about policies and payments.',
        id: 'FAQPage.descriptionMessage.hosting',
    }),
    descriptionMessageIcal: defineMessages({
        defaultMessage: 'Find answers to calendar sync questions on Lodgr. Learn about how it works and how to sync cross platform calendars.',
        id: 'FAQPage.descriptionMessage.ical',
    }),
    descriptionMessagePoints: defineMessages({
        defaultMessage: 'Find answers to loyalty points questions on Lodgr. Learn about redemption and policies.',
        id: 'FAQPage.descriptionMessage.points',
    }),
    descriptionMessagePricing: defineMessages({
        defaultMessage: 'Find answers to pricing questions on Lodgr. Learn about payment methods, refunds and cancellations.',
        id: 'FAQPage.descriptionMessage.pricing',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'FAQ | Lodgr',
        id: 'FAQPage.titleMessage',
    }),
    titleMessageBookings: defineMessages({
        defaultMessage: 'Bookings FAQ | Lodgr',
        id: 'FAQPage.titleMessage.bookings',
    }),
    titleMessageGeneral: defineMessages({
        defaultMessage: 'General FAQ | Lodgr',
        id: 'FAQPage.titleMessage.general',
    }),
    titleMessageHosting: defineMessages({
        defaultMessage: 'Hosting FAQ | Lodgr',
        id: 'FAQPage.titleMessage.hosting',
    }),
    titleMessageIcal: defineMessages({
        defaultMessage: 'Calendar Sync FAQ | Lodgr',
        id: 'FAQPage.titleMessage.ical',
    }),
    titleMessagePoints: defineMessages({
        defaultMessage: 'Loyalty Points FAQ | Lodgr',
        id: 'FAQPage.titleMessage.points',
    }),
    titleMessagePricing: defineMessages({
        defaultMessage: 'Pricing FAQ | Lodgr',
        id: 'FAQPage.titleMessage.pricing',
    }),
}
